<template>
	<div class="home">3</div>
</template>

<script>
export default {
	name: "Home",
};
</script>
